import { forwardRef } from 'react'
import { cn } from '@/lib/utils'

export const Input = forwardRef(function Input(
  {
    className,
    label,
    error,
    hint,
    required,
    leftIcon,
    rightIcon,
    id,
    ...props
  },
  ref,
) {
  const inputId = id || props.name
  return (
    <div className={cn('w-full', className)}>
      {label && (
        <label
          htmlFor={inputId}
          className="mb-1.5 block text-sm font-semibold text-ink-800"
        >
          {label}
          {required && <span className="ml-0.5 text-accent-600">*</span>}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-ink-400">
            {leftIcon}
          </span>
        )}
        <input
          id={inputId}
          ref={ref}
          className={cn(
            'block w-full rounded-xl bg-white text-ink-900 placeholder:text-ink-400',
            'ring-1 ring-inset transition-all duration-150',
            'focus:outline-none focus:ring-2 focus:ring-primary-500',
            error
              ? 'ring-rose-400 focus:ring-rose-500'
              : 'ring-ink-200 hover:ring-ink-300',
            leftIcon ? 'pl-10' : 'pl-3.5',
            rightIcon ? 'pr-10' : 'pr-3.5',
            'h-11 text-sm',
          )}
          {...props}
        />
        {rightIcon && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-ink-400">
            {rightIcon}
          </span>
        )}
      </div>
      {error ? (
        <p className="mt-1.5 text-xs font-medium text-rose-600">{error}</p>
      ) : hint ? (
        <p className="mt-1.5 text-xs text-ink-500">{hint}</p>
      ) : null}
    </div>
  )
})
